import axios from "axios";
import { Message } from "element-ui";
const qs = require("qs");

// 参数格式化函数
const paramsFormat = function (params) {
  let resParams = {};
  for (let i in params) {
    let val = params[i];
    if (Array.isArray(val) && val.length > 0) {
      resParams[i] = val;
    } else if (val && typeof val === "object" && JSON.stringify(val) != "{}") {
      resParams[i] = val;
    } else if (val || val === 0) {
      resParams[i] = val;
    }
  }
  return resParams;
};

// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BRIDGE_API,
  timeout: 120000,
  headers: {
    'Content-Type': 'application/json'
  },
  // // 处理https证书问题
  // httpsAgent: new https.Agent({
  //   rejectUnauthorized: false
  // })
});

// 请求拦截器
service.interceptors.request.use(
  config => {
    // console.log('Target URL:', `${process.env.VUE_APP_BRIDGE_API}/crosschain/records`)
    // config.headers["Content-Type"] = "application/x-www-form-urlencoded";
    // console.log('getBridgeToken',getBridgeToken())
    // if (getBridgeToken()) {
    //   config.headers["Authorization"] = "Bearer " + getBridgeToken();
    // }

    config.vconfig = config.vconfig || {};

    if (config.vconfig.ContentType) {
      config.headers["Content-Type"] = config.vconfig.ContentType;
    }

    if (config.headers["Content-Type"] == "application/x-www-form-urlencoded") {
      config.data = qs.stringify(config.data);
    }

    if (config.vconfig.responseType) {
      config.responseType = config.vconfig.responseType;
    }

    if (config.params) {
      config.params = paramsFormat(config.params);
    }

    return config;
  },
  error => {
    console.log(error);
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  res => {
    const code = res.data.code;
    if (res.config.vconfig && res.config.vconfig.noErr) {
      return res;
    }
    if (code !== 0) {
      return Promise.reject(res.data);
    } else {
      return res.data;
    }
  },
  error => {
    Message({
      message: error.message || "Request failed",
      type: "error",
      duration: 5 * 1000
    });
    return Promise.reject(error);
  }
);

export default service;
